import React from "react";
import { Breadcrumb } from "../../components/ui";
import { useParams } from "react-router-dom";
import { ProgressSpinner } from "primereact/progressspinner";
import { useGetWorkshopByIdQuery } from "../../store/services/workshops";
import { WorkshopForm } from "../../components/Forms/WorkshopForm";

export const EditWorkshop = () => {
  const { workshopId } = useParams();
  const { data, isLoading, refetch } = useGetWorkshopByIdQuery(workshopId || "");

  return (
    <>
      <Breadcrumb items={[{ label: "Talleres", to: "/workshops" }, { label: "Editar taller" }]} />
    <div className="p-card gap-4 p-3">
      <h1 className="text-center text-3xl">Editar Taller</h1>
      {isLoading ? (
        <div className="gap-4 flex flex-column justify-content-center align-items-center p-3 min-h-11rem p-8">
          <h1 className="text-center text-3xl font-bold mb-6">
            Cargando contenido
          </h1>
          <ProgressSpinner />
        </div>
      ) : (
        <WorkshopForm workshopData={data} refetchWorkshopData={refetch} />
      )}
    </div>
    </>
  );
};
